import PartServiceProvider from '../services/PartServiceProvider'
import { StoreInstances } from '../store/StoreInstancesContainer'
import {
  ManufacturerList,
  ManufacturerRequestData,
  PartsList,
} from '../store/models/SearchModels'
import { NonCachedSearchType } from 'interfaces'
import { NavigateFunction } from 'react-router-dom'

export const getPartTypes = (
  data: string,
  navigate?: NavigateFunction
): Promise<PartsList> => {
  return PartServiceProvider.getInterchangePartTypes(data).then((res) => {
    if (res.status === 204) {
      StoreInstances.searchStore.lastNonCachedSearch =
        NonCachedSearchType.searchByInterchange
      navigate('/searchResults')
      return {
        partTypes: [],
        partsBinId: '',
      }
    } else if (res?.data?.partTypes?.length === 0) {
      StoreInstances.searchStore.lastNonCachedSearch =
        NonCachedSearchType.searchByInterchange
      navigate('/searchResults')
      return res.data
    } else {
      return res.data
    }
  })
}

export const getManufacturers = (
  data: ManufacturerRequestData,
  navigate?: NavigateFunction
): Promise<ManufacturerList> => {
  return PartServiceProvider.getInterchangeManufacturerData(data).then(
    (res) => {
      if (res.status === 204) {
        StoreInstances.searchStore.lastNonCachedSearch =
          NonCachedSearchType.searchByInterchange
        navigate('/searchResults')
        return {
          manufacturerList: [],
          partsBinId: '',
        }
      } else if (res?.data?.manufacturerList?.length === 0) {
        StoreInstances.searchStore.lastNonCachedSearch =
          NonCachedSearchType.searchByInterchange
        navigate('/searchResults')
        return res.data
      } else {
        return res.data
      }
    }
  )
}
